import QRCode from 'qrcodejs2'
export default {
  data() {
    return {
      constant:{
          LOGON_TYPE_ID: 1, //账号密码登陆
          LOGON_TYPE_QR: 2, //二维码扫码登陆
          CODE_CACHE_KEY: 'sh_logon_code',//记住密码时账号缓存关键字
          PASS_CACHE_KEY: 'sh_logon_pass',//记住密码时密码缓存关键字
      },
      apis: {
          cfg:'sh/cfg/byCode',//获取系统参数
          captcha: 'sh/captcha/need/captcha',//判断是否需要验证码
          logon: 'sh/oauth/logon',//账号登录接口
          btns: 'sh/user/btns',//获取用户按钮权限
          token: 'sh/oauth/token',//获取登录授权Token
      },
      logonType: 1,//登陆方式，1：账号密码，2：二维码扫码
      captchaImg: false,//是否显示验证码输入框
      remember_me: false, //记住我
      interval:null,//计数器
      params: {
          loginCode: null, //账号
          loginPass: null, //密码
      },
      rules: {
          loginCode: [{ required: true, message: '请输入账号', trigger: 'blur' }],
          loginPass: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      remain: 5
    }
  },
  props:{
      showQR:{//是否显示二维码登陆功能
          type: Boolean,
          default: false,
      },
      border:{//是否显示边框
          type: Boolean,
          default: false,
      },
      type: {//默认登录方式，1：账号密码登陆，2：扫码登陆
          type: Number,
          default : 1
      },
      url:{//扫码后跳转的url路径，系统会自动加上前缀和域名端口，仅仅填写相对路径,系统拼装后：'http://127.0.0.1:8080/#/' + url + '?token=123' 
          type: String,
          default: ''
      },
      titleColor:{//标题颜色
          type: String,
          color: '#000000'
      }
  },
  mounted() {
    const me = this;
    if(me.type && (me.type == me.constant.LOGON_TYPE_ID || me.type == me.constant.LOGON_TYPE_QR)){
        me.logonType == me.type;
    }else{
        me.logonType = me.constant.LOGON_TYPE_ID;
    }
    me.loadTitle();
    me.$set(me.params, 'loginCode', localStorage.getItem(me.constant.CODE_CACHE_KEY));
    me.$set(me.params, 'loginPass', localStorage.getItem(me.constant.PASS_CACHE_KEY));
    if (me.params.loginCode && me.params.loginPass) {
        me.remember_me = true;
    } else {
        me.remember_me = false;
    }
  },
  methods: {
    changeType(){//登录方式修改
        const me = this;
        if(me.logonType == me.constant.LOGON_TYPE_ID){
            me.logonType = me.constant.LOGON_TYPE_QR;
            me.loadToken();
        }else{
            me.logonType = me.constant.LOGON_TYPE_ID;
        }
    },
    loadTitle(){//获取系统配制参数，从而修改网页标题
        const me = this;
        me.$post({
            url: me.apis.cfg,
            params: 'SYS_NAME'
        }).then(rsp => {
            if(rsp.success){
                document.title = rsp.retObj.value;
            }
        })
    },
    logon(){//账号密码登陆
        const me = this;
        let pass = md5(me.params.loginPass).toUpperCase();
        let cacheCode = localStorage.getItem(me.constant.CODE_CACHE_KEY);
        let p = localStorage.getItem(me.constant.PASS_CACHE_KEY);
        if(p && cacheCode == me.params.loginCode){
            pass = p;
        }
        me.$set(me.params, 'password', pass);
        if(!me.remember_me){
            localStorage.removeItem(me.constant.CODE_CACHE_KEY);
            localStorage.removeItem(me.constant.PASS_CACHE_KEY);
        }
        me.$refs['logon_form'].validate((valid) => {
            if (valid) {
                me.$post({
                    url: me.apis.logon,
                    params: me.params
                }).then(rsp => {
                  if (rsp.success) { //成功
                      me.cacheUser(rsp.retObj);
                      
                  } else { //出错
                      if (rsp.exception) {
                        if(rsp.exception.code.toUpperCase() == "LOGON006" ){
                          me.showCaptcha();
                        }
                      } else {
                        me.$message.error('系统发送错误，请联系管理员');
                      }
                  }
                })
            }
        });
    },
    showCaptcha(){//显示验证码
        const me = this;
        me.captchaImg = true;
        me.refreshCaptcha();
    },
    refreshCaptcha(){//刷新验证码
      const me = this;
      if(me.captchaImg){
        let img = me.$refs.captcha;
        img.src = me.$global.baseUrl + "sh/captcha/init?userCode=" + me.params.loginCode + "&width=100&height=40&t=" + new Date(); 
      }
    },
    needCaptcha(){//判断是否需要验证码
        const me = this;
        if(me.captchaImg || me.logonType == me.constant.LOGON_TYPE_QR || !me.params.loginCode){
            return;
        }
        me.$post({
            url: me.apis.captcha,
            params: me.params.loginCode,
        }).then(rsp => {
            if(rsp.retObj){
                me.showCaptcha();
            }
        })
    },
    loadToken(){//获取Token
        const me = this;
        me.$post({
            url: me.apis.token,
            params:{
                appid: 'sys_app',
                appSecret: 'sys_app_secret',
                code: 'sys_app_code',
            }
        }).then(rsp => {
            if(rsp.success){
                me.createQrcode(rsp.retObj);
                me.initSocket(rsp.retObj);
            }
        })
    },
    countTime(){//倒计时
        const me = this;
        if(me.remain > 0){
            me.remain  -= 1;
        }else{
            let dom = me.$refs['qrcode_box'];
            dom && (dom.innerHTML = '二维码已失效，请点击刷新');
            window.clearInterval(me.interval);
        }
    },
    createQrcode(token){//创建二维码
        const me = this, dom = me.$refs['qrcode_box'];
        me.remain = 59;
        me.interval = window.setInterval(me.countTime, 1000);
        let url = window.location.protocol + '//' + window.location.host + window.location.pathname + '/#/' + me.url + '?token = '+ token;
        dom.innerHTML = '';
        new QRCode(dom, {
            text: url, // 需要转换为二维码的内容
            width: 200,
            height: 200,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
        });
    },
    initSocket(token) {//初始化Socket链接
        const me = this,
          server = (me.$global.baseUrl).replace('http', 'ws');
        let socket = new WebSocket(server + "sh/ws/" + token);
        socket.onopen = me.socketOpen;
        socket.onclose = me.socketClose;
        socket.onmessage = me.receiveMsg;
    },
    socketOpen() {//Websocket连接成功
        sessionStorage.setItem('socketOnline', true);
    },
    socketClose() {//Websocket连接关闭成功
        sessionStorage.removeItem('socketOnline');
    },
    receiveMsg(msg) {//Websocket接收消息成功
        const me = this;
        if(msg && msg.data){
            me.interval && window.clearInterval(me.interval);
            me.cacheUser(JSON.parse(msg.data));
        }
    },
    cacheUser(obj) {//缓存用户
      const me = this, user = obj.sysUser, token = obj.token;
      sessionStorage.setItem(me.$global.token, token);
      sessionStorage.setItem(me.$global.userKey, user.userKey);
      sessionStorage.setItem(me.$global.userCode, user.userCode);
      sessionStorage.setItem(me.$global.userName, user.userName);
      sessionStorage.setItem(me.$global.roles, user.roles);
      sessionStorage.setItem(me.$global.userObj, JSON.stringify(user.user)); 
      if (me.remember_me) {//在本地记录密码和账号
          localStorage.setItem(me.constant.CODE_CACHE_KEY, user.userCode);
          localStorage.setItem(me.constant.PASS_CACHE_KEY, me.params.password);
      }
      me.initBtnAuth();
    },
    initBtnAuth(){//初始化用户按钮权限
        const me = this, user = JSON.parse(sessionStorage.getItem(me.$global.userObj));
        if(user.superAdmin == 1){
            me.$router.push('/home');
            return;
        }
        me.$post({
          url: me.apis.btns,
          params: {
              userKey: user.id,
              postKey: user.primaryPost
          }
        }).then(rsp => {
            if(rsp.success){
                let btns = rsp.retList;
                let key = "sh_user_btns_check_" + user.id;
                sessionStorage.removeItem(key);
                if(btns && btns.length > 0){
                    sessionStorage.setItem(key, btns.join(','));
                }
                me.$router.push('/home');
            }
        })
    },
    
  }
}



// WEBPACK FOOTER //
// ./src/components/base/view/cmps/logon/src/logon.js